import { Calendar } from '@assets/svg';
import Input from '@components/Input/Input';
import { lighten, styled } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';

export const StyledInput = styled(Input, {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ theme, open }) => ({
  flex: 1,
  '& .MuiFilledInput-root': {
    '&.Mui-focused': {
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: `0 0 0 4px ${lighten(theme.palette.primary.main, 0.8)}`,
    },
  },
  '& label': {
    '&.Mui-focused': {
      color: theme.palette.primary.main,
    },
    maxWidth: 'calc(100% - 50px)'
  },
  ...(open && {
    '&& .MuiFilledInput-root': {
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: `0 0 0 4px ${lighten(theme.palette.primary.main, 0.8)}`,
    },
    '&& label': {
      color: theme.palette.primary.main,
    },
  }),
}));

export const DayPicker = styled(PickersDay)(({ theme }) => ({
  '&.MuiPickersDay-today': {
    borderRadius: 4,
    backgroundColor: 'transparent',
    borderColor: theme.palette.primary.main,
  }, 
  '&.Mui-selected': {
    borderRadius: 4,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  '&.Mui-selected:focus': {
    borderRadius: 4,
    backgroundColor: `${theme.palette.primary.main}`,
    color: theme.palette.common.white,
  },
  '&:hover': {
    borderRadius: 4,
    backgroundColor: lighten(theme.palette.primary.main, 0.7),
  },
})) as typeof PickersDay<Date>;

export const CalendarIcon = styled(Calendar,{
  shouldForwardProp: (prop) => prop !== 'hasValue',
})<{ hasValue: boolean }>(({theme, hasValue}) => ({
  color: hasValue ? theme.palette.text.primary : theme.palette.grey.A100
}))